<template>
  <div class="box">
    <div id="app-home1">
      <div class="jinbi1" v-if="list.point && list.reply">
        <img src="@/assets/medal/quaquaka/jinbi.png" alt="" />
        <span>积分 +{{ list.point }} </span>
      </div>
      <div class="heartCon" v-if="!activeHeart && heartnums < 1">
        <img
          class="back"
          src="../../../assets/medal/quaquaka/background10.png"
          alt=""
        />
      </div>
      <div class="heartCon" v-if="!activeUpvote && likesnums < 1">
        <img
          class="back"
          src="../../../assets/medal/quaquaka/background9.png"
          alt=""
        />
      </div>
      <!-- <div class="top1" v-if="list.tips">
        <div class="tips">
          <span>{{ list.tips }}</span>
        </div>
      </div> -->
      <div
        class="top2"
        v-if="list.ccEmpno?.includes($store.state.userInfo.username)"
      >
        <div class="cc">获赠人：</div>
        <div class="cclist">
          <div class="list_con">
            <span>{{ list?.receivername }}</span>
          </div>
        </div>
      </div>
      <div
        class="top1"
        :class="
          list.ccEmpno?.includes($store.state.userInfo.username)
            ? 'top4'
            : 'top3'
        "
      >
        <div class="cc" v-if="list.ccers?.length > 0">抄送人：</div>
        <div
          class="cclist"
          :class="
            list.ccEmpno?.includes($store.state.userInfo.username)
              ? 'cclist1'
              : 'cclist2'
          "
          v-if="list.ccers?.length > 0"
        >
          <div class="list_con" v-for="item in list.ccers" :key="item">
            <span>{{ item }}</span>
          </div>
        </div>
      </div>
      <div class="card1">
        <div class="card-box">
          <div class="card-left">
            <div class="card-title">
              <img :src="list.avatar" alt="" />
              <div>{{ list.sendername }}</div>
            </div>
            <div class="card-con">
              {{
                base.test(list.reason)
                  ? base64ToString(list.reason)
                  : list.reason
              }}
            </div>
            <div class="button_con" v-if="list.iconId">
              <!-- <el-button style="padding:5px 8px;font-size: 13px;background-color: #dbf6d3;color: #387fb0;border: 0;"># {{ list.medalName }}</el-button> -->
              <img :src="imgUrl + list.iconId" alt="" />
            </div>
          </div>
          <!-- <div class="card-right" v-if="list.replyname">
            <div class="card-title">
              <div>{{ list.replyname }}说：</div>
              <img :src="list.replyavatar" alt="" />
            </div>
            <div class="card-con">
              {{ list.replyreson }}
            </div>
          </div> -->
        </div>
      </div>
      <div class="operation">
        <div class="bixin">
          <img
            v-if="list.heartStatus == 1"
            src="@/assets/medal/quaquaka/smallBixin.png"
            alt=""
            @click="handleHeart"
          />
          <img
            v-else
            @click="handleActiveHeart"
            src="@/assets/medal/quaquaka/activeBixin.png"
            alt=""
          />
          <span style="font-size: 12px">{{ list.heartnums }}</span>
        </div>
        <div class="bixin">
          <!-- v-if="!(list.comment && list.comment.length > 0)" -->
          <img
            v-if="list.commentStatus == 1"
            src="@/assets/medal/quaquaka/pinglun.png"
            alt=""
            @click="handleClickComment"
          />
          <img
            v-else
            @click="handleClickActiveComment"
            src="@/assets/medal/quaquaka/activePinglun.png"
            alt=""
          />
        </div>
        <div class="bixin">
          <img
            v-if="list.likeStatus == 1"
            src="@/assets/medal/quaquaka/smallDianzan.png"
            alt=""
            @click="handleClickUpvote"
          />
          <img
            v-else
            @click="handleClickActiveUpvote"
            src="@/assets/medal/quaquaka/activeDianzan.png"
            alt=""
          />

          <span style="font-size: 12px; margin-left: 3px">{{
            list.likesnums
          }}</span>
        </div>
      </div>
      <div class="replyCon">
        <div class="card-left" v-if="list.replyreason">
          <div class="card-title">
            <img :src="list.receivericon" alt="" />
            <div>{{ list.receivername }}的回复：</div>
          </div>
          <div class="card-con">
            {{
              base.test(list.replyreason)
                ? base64ToString(list.replyreason)
                : list.replyreason
            }}
          </div>
        </div>
        <div
          class="card-left"
          v-for="(item, index) in list.comment"
          :key="index"
        >
          <div class="card-title">
            <img :src="item.avatar" alt="" />
            <div>{{ item.sendername }}的评论：</div>
          </div>
          <div class="card-con">
            {{
              base.test(item.reason) ? base64ToString(item.reason) : item.reason
            }}
          </div>
        </div>
      </div>
      <div class="logo1" v-if="list.reply !== 0">
        <el-button class="btnOk" @click="handleReply" v-if="list.reply == 1">
          立即回复
        </el-button>
        <el-button class="btnNo" v-if="list.reply == 2"> 已回复 </el-button>
      </div>
    </div>
    <van-dialog
      class="dialog"
      v-model="showTip"
      :showConfirmButton="false"
      z-index="1999"
    >
      <div class="dialog-people">回复：{{ list.sendername }}</div>
      <div class="dialog-reason">
        <div>
          <van-field
            v-model="message"
            rows="2"
            autosize
            type="textarea"
            maxlength="200"
            placeholder="请输入回复内容，内容仅限200字以内。"
            show-word-limit
          />
        </div>
      </div>
      <div class="dialog-btn">
        <el-button @click="handelNo">取消</el-button>
        <el-button
          @click="handelOk"
          style="background: rgba(72, 158, 108, 1); color: #fff"
          :disabled="disabled"
          >发送</el-button
        >
      </div>
    </van-dialog>
    <van-dialog
      class="dialog"
      v-model="showComment"
      :showConfirmButton="false"
      z-index="1999"
    >
      <div class="dialog-people">评论：</div>
      <div class="dialog-reason">
        <div>
          <van-field
            v-model="comment"
            rows="2"
            autosize
            type="textarea"
            maxlength="200"
            placeholder="请输入评论内容，内容仅限200字以内。"
            show-word-limit
          />
        </div>
      </div>
      <div class="dialog-btn">
        <el-button @click="handelNoComment">取消</el-button>
        <el-button
          @click="handelOkComment"
          style="background: rgba(72, 158, 108, 1); color: #fff"
          :disabled="disabled"
          v-loading="disabled"
          >评论</el-button
        >
      </div>
    </van-dialog>
  </div>
</template>

<script>
import api from "@/apis/medal";
import apiLogin from "@/apis";
import { getToken } from "@/utils/cookie";
export default {
  name: "quaquakaDetail",
  data() {
    return {
      list: {},
      showTip: false,
      message: "",
      disabled: false,
      id: "",
      cclist: [],
      activeHeart: true,
      activeUpvote: true,
      showComment: false,
      comment: "",
      heartnums: 0,
      likesnums: 0,
      empno: "",
      pinglun: true,
      showHeart: true,
      showUpvote: true,
      imgUrl: "",
      base: /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)?$/
    };
  },
  created() {},
  mounted() {
    this.imgUrl = api.imgUrl;
    this.id = this.$route.query.id;
    let token = window.sessionStorage.hrToken;
    let hrToken = getToken();
    if (token) {
      this.empno = hrToken;
      this.getList();
    } else {
      this.$bus.$on("processToken", res => {
        this.empno = res;
        console.log(res);
        Promise.resolve(this.getHrToken(res)).then(() => {
          this.getList();
        });
      });
    }
  },
  beforeDestroy() {
    sessionStorage.setItem("isShowBadge", true);
  },
  methods: {
    //获取hrToken&用户信息
    getHrToken(username) {
      return new Promise(resolve => {
        // console.log("username:" + new Date(), username);
        if (username) {
          let thisname = username;

          if (thisname === "17625010228" || thisname === "17637403245") {
            thisname = "10005038";
          } else if (thisname === "15093054787") {
            thisname = "10005038";
          }

          apiLogin.getUserToken({ username: thisname }).then(data => {
            // console.log(data);
            const info = data.data;

            localStorage.setItem("salaryPhone", info.mobileNo);
            localStorage.setItem("salaryInfo", JSON.stringify(info));

            window.sessionStorage.hrToken = info.auth_token;
            resolve();
          });
        } else {
          // console.log("未登录");
          resolve();
        }
      });
    },
    // 将 Base64 编码的字符串转换为原始字符串
    base64ToString(base64Str) {
      // 将 Base64 编码的字符串转换为二进制数据
      const binaryString = window.atob(base64Str);

      // 将二进制数据转换为 Uint8Array
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      // 使用 TextDecoder 将二进制数据转换为字符串
      const decoder = new TextDecoder("utf-8");
      const originalString = decoder.decode(bytes);

      return originalString;
    },
    //获取点赞卡详情
    getList() {
      api
        .medalCardDetailApi({
          id: this.id,
          empno: this.empno,
          channel: this.$route.query.value
        })
        .then(res => {
          if (res.code == 200) {
            const checkList =
              res.data.receiverEmpno +
              "," +
              res.data.senderEmpno +
              "," +
              res.data.ccEmpno;
            if (checkList.includes(this.empno)) {
              this.list = res.data;
              this.list.ccerss = res.data.ccers.join(",");

              // this.list.reason = this.base64ToString(res.data.reason);
              setInterval(function () {
                this.heartnums = res.data.heartnums;
                this.likesnums = res.data.likesnums;
              }, 4000);
            } else {
              this.$router.push({
                path: "/mobile/medal"
              });
            }
          }
        })
        .catch(err => {
          if (err.code === 0) {
            this.$message({
              type: "error", // success error warning
              message: err.message,
              duration: 2000
            });
          }
        });
    },
    //点击回复
    handleReply() {
      this.showTip = true;
    },
    //点击取消回复
    handelNo() {
      this.message = "";
      this.showTip = false;
    },
    //确认回复
    handelOk() {
      if (!this.message) {
        return this.$message({
          message: "请填写回复内容",
          type: "warning"
        });
      }
      if (!/[\u4e00-\u9fa5]/.test(this.message)) {
        return this.$message.warning("回复必须包含文字哦");
      }
      const message = this.stringToBase64(this.message);
      const data = {
        id: this.id,
        reason: message,
        // empno: this.list.senderEmpno
        empno: getToken()
      };
      this.disabled = true;
      api
        .medalCardReplyApi(data)
        .then(data => {
          this.disabled = false;
          this.showTip = false;
          this.getList();
          console.log(data, "data");
        })
        .catch(() => {
          this.disabled = false;
        });
    },
    //点击评论
    handleClickComment() {
      this.comment = "";
      this.showComment = true;
    },
    //点击评论
    handleClickActiveComment() {
      this.$message({
        type: "error", // success error warning
        message: "您已经评论，不能进行重复评论",
        duration: 2000
      });
    },
    //取消评论
    handelNoComment() {
      this.comment = "";
      this.showComment = false;
    },
    // 将字符串转换为 Base64 编码
    stringToBase64(str) {
      // 将字符串转换为 UTF-8 编码的二进制数据
      const encoder = new TextEncoder();
      const uint8Array = encoder.encode(str);

      // 将二进制数据转换为 Base64 编码
      const base64String = btoa(String.fromCharCode.apply(null, uint8Array));
      return base64String;
    },
    //评论
    handelOkComment() {
      if (!this.comment) {
        return this.$message({
          message: "请填写评论内容",
          type: "warning"
        });
      }
      if (!/[\u4e00-\u9fa5]/.test(this.comment)) {
        return this.$message.warning("评论必须包含文字哦");
      }
      if (!this.disabled) {
        const comment = this.stringToBase64(this.comment);
        const data = {
          id: this.id,
          reason: comment,
          empno: getToken()
        };
        this.disabled = true;
        api
          .medalCardCommentApi(data)
          .then(data => {
            this.showComment = false;
            this.getList();
            console.log(data, "data");
            setTimeout(() => {
              this.disabled = false;
            }, 2000);
          })
          .catch(error => {
            this.showComment = false;
            this.$message({
              type: "error", // success error warning
              message: error.message,
              duration: 2000
            });
          });
      }
    },
    // 比心
    handleHeart() {
      if (this.showHeart) {
        this.activeHeart = false;
        const json = {
          id: this.id,
          type: 2,
          empno: getToken()
        };
        this.showHeart = false;
        api
          .medalCardLikesApi(json)
          .then(() => {
            this.getList();
            this.showHeart = true;
          })
          .catch(error => {
            this.$message({
              type: "error", // success error warning
              message: error.message,
              duration: 2000
            });
          });
      }
    },
    // 点击比心
    handleActiveHeart() {
      this.$message({
        type: "error", // success error warning
        message: "您已经对当前徽章进行过比心",
        duration: 2000
      });
      // const json = {
      //   id: this.id,
      //   type: 2
      // };
      // api.likesApi(json).then(() => {
      //   this.getList();
      // }).catch((error) => {
      //   this.$message({
      //     type: "error", // success error warning
      //     message: error.message,
      //     duration: 2000,
      //   });
      // });
    },
    // 点赞
    handleClickUpvote() {
      if (this.showUpvote) {
        this.activeUpvote = false;
        const json = {
          id: this.id,
          type: 1,
          empno: getToken()
        };
        this.showUpvote = false;
        api
          .medalCardLikesApi(json)
          .then(res => {
            this.getList();
            console.log(res);
            this.showUpvote = true;
          })
          .catch(error => {
            this.$message({
              type: "error", // success error warning
              message: error.message,
              duration: 2000
            });
          });
      }
    },
    // 点击点赞
    handleClickActiveUpvote() {
      this.$message({
        type: "error", // success error warning
        message: "您已经对当前徽章进行过点赞",
        duration: 2000
      });
      // const json = {
      //   id: this.id,
      //   type: 1
      // };
      // api.likesApi(json).then((res) => {
      //   this.getList();
      //   console.log(res);
      // }).catch((error) => {
      //   this.$message({
      //     type: "error", // success error warning
      //     message: error.message,
      //     duration: 2000,
      //   });
      // });
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  #app-home {
    width: 100%;
    background: rgba(244, 245, 248, 1);
    min-height: 100vh;
  }

  #app-home1 {
    width: 100%;
    background: rgba(244, 245, 248, 1);
    min-height: 100vh;
  }
}

@media screen and (min-width: 600px) {
  #app-home {
    width: 276px * $zoom;
    background: rgba(244, 245, 248, 1);
    min-height: 100vh;
  }

  #app-home1 {
    // width: 276px * $zoom;
    width: 276px * $zoom;
    background: rgba(244, 245, 248, 1);
    min-height: 100vh;
  }
}

@keyframes floatAndFade {
  0% {
    opacity: 0;
    /* 初始不透明度为1 */
  }

  25% {
    opacity: 0.5;
  }

  50% {
    opacity: 1;
  }

  75% {
    opacity: 0.5;
    /* 保持不透明度 */
  }

  100% {
    opacity: 0;
    /* 最终透明度为0 */
  }
}

.box {
  width: 100%;
  display: flex;
  justify-content: center;

  #app-home {
    background: url("~@/assets/medal/quaquaka/detail.png");
    background-size: 100% 100%;
    padding: 50px 60px 100px;
    position: relative;
  }

  .jinbi {
    position: absolute;
    top: 10px;
    left: calc(50% - 200px);
    display: flex;
    align-items: center;
    animation: floatAndFade 4s ease forwards;

    img {
      width: 80px;
      height: 80px;
    }

    span {
      font-size: 40px;
    }
  }

  .top {
    background: url("~@/assets/medal/quaquaka/cc.png");
    background-size: 100% 100%;
    height: 22%;
    width: 80.5%;
    z-index: 1;
    left: 10%;
    position: absolute;
    top: 4%;
    font-size: 10px * $zoom;
    display: flex;
    padding-top: 20px;

    .cc {
      padding: 10px 0 0 20px;
      // flex-shrink: 0;
    }

    .cclist {
      padding: 10px 0 0 0;
      margin-right: 20px;
      display: flex;
      flex-wrap: wrap;

      div:nth-child(3) {
        margin-top: 3px;
      }

      span {
        background: rgb(200, 247, 191);
        padding: 10px 20px;
        border-radius: 10px;
        margin-right: 20px;
      }
    }

    .tips {
      padding-left: 30px;
      padding-top: 20px;

      span {
        background: rgb(200, 247, 191);
        padding: 10px 20px;
        border-radius: 10px;
        margin-right: 20px;
      }
    }
  }

  .card {
    background: url("~@/assets/medal/quaquaka/card.png");
    background-size: 100% 100%;
    height: 84.5%;
    // width: 630px;
    position: relative;
    z-index: 2;
    top: 8%;

    .card-box {
      position: absolute;
      width: 100%;
      height: 54%;
      // background: red;
      // margin-top: 37%;
      top: 18%;
      overflow: auto;
      padding: 0 0 0 60px;
      scrollbar-width: none;
      /* firefox */
      -ms-overflow-style: none;

      /* IE 10+ */
      &::-webkit-scrollbar {
        display: none;
        /* Chrome Safari */
      }
    }

    .card-left {
      .card-title {
        // position: absolute;
        // top: 18%;
        // left: 11%;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        img {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          margin-right: 10px;
        }

        div {
          width: auto;
          height: 60px;
          padding: 0 0 0 30px;
          line-height: 60px;
          font-size: 28px;
          background: url("~@/assets/medal/quaquaka/message.png");
          background-size: 100% 100%;
          color: #fff;
        }
      }

      .card-con {
        // position: absolute;
        // top: 26%;
        // left: 11%;
        font-size: 27px;
        padding-right: 46px;
        line-height: 50px;
      }
    }

    .card-right {
      .card-title {
        // position: absolute;
        // top: 18%;
        // left: 11%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-bottom: 20px;
        margin-top: 20px;

        img {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          margin-left: 10px;
          margin-right: 50px;
        }

        div {
          width: auto;
          height: 60px;
          padding: 0 20px 0 20px;
          line-height: 60px;
          font-size: 28px;
          background: url("~@/assets/medal/quaquaka/messageRight.png");
          background-size: 100% 100%;
          color: #fff;
        }
      }

      .card-con {
        // position: absolute;
        // top: 26%;
        // left: 11%;
        font-size: 27px;
        padding-right: 46px;
        line-height: 50px;
      }
    }
  }

  .logo {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 150px;
    position: absolute;
    bottom: 5%;
    left: 26%;
    z-index: 3;

    img {
      width: 240px;
      height: 50px;
    }

    .btnOk {
      background: rgba(106, 212, 150, 1);
      border: none;
      width: 350px;
      height: 90px;
      font-size: 30px;
      color: #fff;
      border-radius: 50px;
    }

    .btnNo {
      background: rgba(217, 217, 217, 1);
      border: none;
      width: 350px;
      height: 90px;
      font-size: 30px;
      color: rgba(162, 162, 162, 1);
      border-radius: 50px;
    }
  }

  .dialog {
    height: 190px * $zoom;
    padding: 30px;

    .dialog-people {
      margin-bottom: 30px;
    }

    .dialog-reason {
      ::v-deep {
        .van-cell {
          background: rgba(244, 244, 244, 1);
          margin-top: 30px;
          height: 280px;
        }

        .van-field__control {
          height: 200px !important;
        }
      }
    }

    .dialog-btn {
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin-top: 30px;
      width: 100%;

      button {
        width: 200px;
        height: 80px;
        border-radius: 40px;
        font-size: 28px;
      }
    }
  }

  @keyframes heartAndRotate {
    0% {
      opacity: 0;
      transform: scale(0.4);
      /* 初始不透明度为1 */
    }

    15% {
      opacity: 0.3;
      // transform: scale(0.5);
    }

    25% {
      opacity: 0.5;
      // transform: scale(0.6);
    }

    35% {
      opacity: 0.8;
      // transform: scale(0.7);
    }

    50% {
      opacity: 1;
      // transform: scale(0.8);
    }

    60% {
      opacity: 0.8;
      // transform: scale(1);
    }

    75% {
      opacity: 0.5;
      // transform: scale(1.2);
    }

    90% {
      opacity: 0.3;
      transform: scale(1.3);
    }

    100% {
      opacity: 0;
      /* 最终透明度为0 */
      transform: scale(1.5);
    }
  }

  #app-home1 {
    background: url("~@/assets/medal/quaquaka/background14.png");
    background-size: 100% 100%;
    // padding: 50px 60px 100px;
    position: relative;

    .jinbi1 {
      position: absolute;
      top: 10px;
      left: calc(50% - 200px);
      display: flex;
      align-items: center;
      animation: floatAndFade 4s linear forwards;

      img {
        width: 80px;
        height: 80px;
      }

      span {
        font-size: 40px;
      }
    }

    .heartCon {
      width: 78%;
      height: 28%;
      position: absolute;
      top: 32%;
      left: 16%;
      animation: heartAndRotate 4s ease forwards;

      .back {
        width: 83%;
      }

      .dianzan {
        width: 38%;
        position: absolute;
        top: 38%;
        left: 21%;
      }
    }
    .top3 {
      top: 11%;
    }
    .top4 {
      top: 14%;
    }
    .top1 {
      height: 11%;
      width: 62.5%;
      z-index: 1;
      left: 30%;
      position: absolute;

      font-size: 10px * $zoom;
      display: flex;
      padding-top: 20px;

      .cc {
        padding: 5px 0 0 20px;
        flex-shrink: 0;
        font-size: 24px;
      }
      .list_con {
        height: 34px;
      }
      .cclist1 {
        height: 72%;
        padding: 10px 0 0 0;
        // margin-right: 20px;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        overflow-y: auto;
        &::-webkit-scrollbar {
          display: none;
        }
      }
      .cclist2 {
        // width: 72%;
        height: 93%;
        padding: 10px 0 0 0;
        // margin-right: 20px;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        overflow-y: auto;
        &::-webkit-scrollbar {
          display: none;
        }
      }
      .cclist {
        div:nth-child(3) {
          margin-top: 3px;
        }

        div {
          margin-bottom: 10px;
        }

        span {
          font-size: 22px;
          background: #f9f0d1;
          padding: 10px 10px;
          border-radius: 10px;
          margin-right: 10px;
        }
      }

      .tips {
        padding-left: 30px;
        padding-top: 20px;
        font-size: 22px;

        span {
          background: #f9f0d1;
          padding: 10px 20px;
          border-radius: 10px;
          margin-right: 20px;
        }
      }
    }
    .top2 {
      height: 11%;
      width: 62.5%;
      z-index: 1;
      left: 30%;
      position: absolute;
      top: 10.4%;
      font-size: 10px * $zoom;
      display: flex;
      padding-top: 20px;

      .cc {
        padding: 10px 0 0 20px;
        flex-shrink: 0;
        font-size: 24px;
      }
      .list_con {
        height: 34px;
      }
      .cclist {
        // width: 53%;
        padding: 10px 0 0 0;
        // margin-right: 20px;
        display: flex;
        flex-wrap: wrap;
        font-size: 22px;
        div:nth-child(3) {
          margin-top: 3px;
        }

        div {
          margin-bottom: 10px;
        }

        span {
          font-size: 22px;
          background: #f9f0d1;
          padding: 10px 10px;
          border-radius: 10px;
          margin-right: 10px;
        }
      }

      .tips {
        padding-left: 30px;
        padding-top: 20px;
        font-size: 22px;

        span {
          background: #f9f0d1;
          padding: 10px 20px;
          border-radius: 10px;
          margin-right: 20px;
        }
      }
    }

    .card1 {
      height: 18%;
      width: 80%;
      position: relative;
      z-index: 2;
      top: 26%;
      left: 11%;

      .card-box {
        position: absolute;
        width: 100%;
        height: 100%;
        // background: red;
        // margin-top: 37%;
        // top: 18%;
        // overflow: auto;
        // padding: 0 0 0 60px;
        scrollbar-width: none;
        /* firefox */
        -ms-overflow-style: none;

        /* IE 10+ */
        &::-webkit-scrollbar {
          display: none;
          /* Chrome Safari */
        }
      }

      .card-left {
        height: 100%;
        position: relative;
        .card-title {
          display: flex;
          align-items: center;

          img {
            width: 70px;
            height: 70px;
            border-radius: 50%;
            margin-right: 10px;
          }

          div {
            width: auto;
            height: 60px;
            line-height: 30px;
            font-size: 28px;
            color: #191b28;
          }
        }

        .card-con {
          height: 68%;
          font-size: 27px;
          line-height: 50px;
          text-indent: 2em;
          overflow-y: auto;
          scrollbar-width: none;
          /* firefox */
          -ms-overflow-style: none;

          /* IE 10+ */
          &::-webkit-scrollbar {
            display: none;
            /* Chrome Safari */
          }
        }
        .button_con {
          position: absolute;
          // right: 60px;
          // bottom:-170px;
          right: 10%;
          bottom: -67%;
          width: 200px;
          height: 200px;
          background: url("~@/assets/medal/quaquaka/background13.png");
          background-size: 100% 100%;
          img {
            position: relative;
            width: 200px;
            height: 200px;
            z-index: 9999;
          }
        }
      }

      .card-right {
        .card-title {
          // position: absolute;
          // top: 18%;
          // left: 11%;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          margin-bottom: 20px;
          margin-top: 20px;

          img {
            width: 70px;
            height: 70px;
            border-radius: 50%;
            margin-left: 10px;
            margin-right: 50px;
          }

          div {
            width: auto;
            height: 60px;
            padding: 0 20px 0 20px;
            line-height: 60px;
            font-size: 28px;
            // background: url("~@/assets/medal/quaquaka/messageRight.png");
            // background-size: 100% 100%;
            color: #191b28;
          }
        }

        .card-con {
          // position: absolute;
          // top: 26%;
          // left: 11%;
          font-size: 27px;
          padding-right: 46px;
          line-height: 50px;
        }
      }
    }

    .operation {
      position: relative;
      z-index: 2;
      top: 46.5%;
      left: 12%;
      display: flex;
      align-items: center;
      width: 68%;
      .bixin {
        margin-right: 10px;

        img {
          width: 35px;
          height: 30px;
          margin-left: 10px;
        }
      }
    }

    .replyCon {
      height: 11.5%;
      width: 63%;
      position: relative;
      z-index: 2;
      top: 47%;
      left: 19%;
      border-radius: 10px;
      overflow-y: auto;
      scrollbar-width: none;
      /* firefox */
      -ms-overflow-style: none;

      /* IE 10+ */
      &::-webkit-scrollbar {
        display: none;
        /* Chrome Safari */
      }

      .card-left {
        // height: 100%;

        .card-title {
          display: flex;
          align-items: center;

          img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin-right: 10px;
          }

          div {
            width: auto;
            // height: 60px;
            line-height: 60px;
            font-size: 22px;
            color: #191b28;
          }
        }

        .card-con {
          width: 100%;
          // height: 68%;
          font-size: 22px;
          line-height: 40px;
          text-indent: 1em;
        }
      }
    }

    .logo1 {
      display: flex;
      align-items: center;
      justify-content: center;
      // padding-top: 150px;
      position: absolute;
      bottom: 8%;
      left: 36%;
      z-index: 3;

      img {
        width: 240px;
        height: 50px;
      }

      .btnOk {
        // background: rgba(106, 212, 150, 1);
        border: none;
        width: 200px;
        height: 65px;
        font-size: 28px;
        color: #fff;
        border-radius: 50px;
        background: linear-gradient(359deg, #36913b 0%, #aaf378 100%),
          linear-gradient(
            180deg,
            rgba(0, 143, 89, 0) 0%,
            rgba(0, 209, 4, 0) 72%,
            #22e505 100%
          );
        box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.3);
      }

      .btnNo {
        border: none;
        width: 200px;
        height: 65px;
        font-size: 28px;
        color: #fff;
        border-radius: 50px;
        background: linear-gradient(359deg, #d8e1d8 0%, #bbf098 100%),
          linear-gradient(
            180deg,
            rgba(0, 143, 89, 0) 0%,
            rgba(0, 209, 4, 0) 72%,
            #a2e597 100%
          );
        box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.3);
      }
    }
  }
}
</style>
